module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"unit.seconds":"second | seconds","unit.images":"image | images"},"de":{"up to":"bis zu","unit.seconds":"Sekunde | Sekunden","unit.images":"Bild | Bilder"}}')
  delete Component.options._Ctor
}
